import React, { useState } from 'react';
/**
import correoElectronicoPendiente from "../../common/assets/correo-electronico-pendiente.png";
import mensajeDelCorazonDelTelefono from "../../common/assets/mensaje-del-corazon-del-telefono.png";
**/
interface RadioButtonOptionsProps {
  email: string;
  telephone: string;
  handleVerificationMethod: (method: number) => void;
}

const RadioButtonOptions: React.FC<RadioButtonOptionsProps> = ({ email, telephone, handleVerificationMethod }) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [focusedValue, setFocusedValue] = useState<string | null>(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
    handleVerificationMethod(Number(event.target.value));
  };

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    setFocusedValue(event.target.value);
  };

  const handleBlur = () => {
    setFocusedValue(null);
  };

  const correoElectronicoPendiente = "/documents/d/guest/correo-electronico-pendiente";
  const mensajeDelCorazonDelTelefono = "/documents/d/guest/mensaje-del-corazon-del-telefono";

  return (
    <div className="warp-items-select">
      <div className="pasarella_box">
        <div className="pasarella_box-title">
          <img
            src={correoElectronicoPendiente}
            loading="lazy"
            alt="Correo electrónico pendiente"
            className="pasarella_box-icon"
          />
          <div>Enviar mail a {email}</div>
        </div>
        <label className="w-radio">
          <div
            className={`w-form-formradioinput w-form-formradioinput--inputType-custom pasarella_box-radiobutton w-radio-input ${selectedValue === '1' ? 'w--redirected-checked' : ''} ${focusedValue === '1' ? 'w--redirected-focus' : ''}`}
          ></div>
          <input
            type="radio"
            name="mensaje"
            id="mail"
            data-name="mensaje"
            style={{
              opacity: 0,
              position: "absolute",
              zIndex: -1,
            }}
            value="1"
            onChange={handleRadioChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <span className="is-hide w-form-label">
            Enviar mail a {email}
          </span>
        </label>
      </div>
      <div className="pasarella_box">
        <div className="pasarella_box-title">
          <img
            src={mensajeDelCorazonDelTelefono}
            loading="lazy"
            alt="Mensaje del corazón del teléfono"
            className="pasarella_box-icon"
          />
          <div>Enviar SMS a {telephone}</div>
        </div>
        <label className="w-radio">
          <div
            className={`w-form-formradioinput w-form-formradioinput--inputType-custom pasarella_box-radiobutton w-radio-input ${selectedValue === '2' ? 'w--redirected-checked' : ''} ${focusedValue === '2' ? 'w--redirected-focus' : ''}`}
          ></div>
          <input
            type="radio"
            name="mensaje"
            id="sms"
            data-name="mensaje"
            style={{
              opacity: 0,
              position: "absolute",
              zIndex: -1,
            }}
            value="2"
            onChange={handleRadioChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <span className="is-hide w-form-label">
            Enviar SMS a {telephone}
          </span>
        </label>
      </div>
    </div>
  );
};

export default RadioButtonOptions;